import React from 'react';
import {
  Grid,
  Box,
  Container,
  Typography,
  IconButton,
  Link
} from '@mui/material';

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer: React.FC = () => {
 return (
 <Box
 component="footer"
 sx={{
 bgcolor: 'background.paper',
 pt: 4,
 pb: 14,
 mt: 8,
 borderTop: '2px solid',
 borderColor: 'primary.main'}}
 >
 <Container maxWidth="lg">
 <Grid container spacing={4}>
 <Grid item xs={12} md={4}>
 <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
 EFECTO<span style={{ color: '#DC143C' }}>FM</span>
 </Typography>
 <Typography variant="body2" color="text.secondary">
 Tu emisora favorita en el 89.0 MHz
 </Typography>
 <Typography variant="body2" color="text.secondary">
 Música las 24 horas del día
 </Typography>
 </Grid>

 <Grid item xs={12} md={4}>
 <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
 CONTACTO
 </Typography>
 <Typography variant="body2" color="text.secondary">
 Email: contacto@efectofm.es
 </Typography>
 <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
 <Link
 href="https://wa.me/34621120000?text=Hola%20EfectoFM!"
 target="_blank"
 sx={{
 display: 'flex',
 alignItems: 'center',
 color: 'text.secondary',
 textDecoration: 'none',
 '&:hover': {
 color: 'primary.main'
 }
 }}
 >
 <WhatsAppIcon sx={{ mr: 1, fontSize: '1.2rem' }} />
 <Typography variant="body2">
 +34 621 12 00 00
 </Typography>
 </Link>
 </Box>
 </Grid>

 <Grid item xs={12} md={4}>
 <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
 SÍGUENOS
 </Typography>
 <Box sx={{ display: 'flex', gap: 1 }}>
 <IconButton
 component={Link}
 href="https://www.instagram.com/efectofm/"
 target="_blank"
 sx={{ color: 'primary.main' }}
 >
 <InstagramIcon />
 </IconButton>
 <IconButton
 component={Link}
 href="https://www.facebook.com/efectofm/"
 target="_blank"
 sx={{ color: 'primary.main' }}
 >
 <FacebookIcon />
 </IconButton>
 <IconButton
 component={Link}
 href="https://wa.me/34621120000"
 target="_blank"
 sx={{ color: 'primary.main' }}
 >
 <WhatsAppIcon />
 </IconButton>
 </Box>
 </Grid>
 </Grid>

 <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
 <Typography variant="body2" color="text.secondary" align="center">
 © {new Date().getFullYear()} EfectoFM. Todos los derechos reservados.
 </Typography>
 <Typography variant="body2" align="center" sx={{ mt: 1 }}>
 <Link
 href="/aviso-legal.html"
 sx={{
 color: 'text.secondary',
 textDecoration: 'none',
 '&:hover': {
 color: 'primary.main'
 }
 }}
 >
 Aviso Legal · Privacidad · Cookies
 </Link>
 </Typography>
 </Box>
 </Container>
 </Box>
 );
};

export default Footer;